import React, { useEffect} from 'react';
import TopNav from './TopNav';
import { Outlet } from 'react-router-dom';
import { checkInitialLogin } from '../features/authentication/authenticationSlice';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import Authentication from './Authentication';
import Footer from './Footer';
import './style/main.css'

const Main = () => {    
    const checkSessionStatus = async () => {
        if(window.location.pathname.slice(0,10) === "/register/")
            return;
        checkInitialLogin();
    };
    

    useEffect(() => {
        checkSessionStatus();
        const handle = setInterval(checkSessionStatus, 60000);
        return () => {
            clearInterval(handle);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <div className="app-container">
            <TopNav/>
            <main className="app-content">
            <Outlet />
            <Authentication />
            <ToastContainer
                position="top-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            </main>
            <Footer/>
        </div>
    );
};

export default Main;